import React from 'react'
import Config from "../../../config/Config";
import WidgetLoading from '../../../widget/WidgetLoading';
import JobCard from '../job/jobCard';
import NoData from '../NoData';
import { formatSalaryRange, getSalaryDisplay, tagRedirect } from '../utils'
import "./card.scss";
let filePath = Config.getFilePath();

class card extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  async componentDidMount() {

  }

  info = (data) => {
    const { type } = this.props;
    if (type === 'ent') {
      this.props.history.push({ pathname: "/home/enterprise/detail", state: { data } })
    } else {
      this.props.history.push({ pathname: "/home/jobdetails", state: { data } })
    }
  }

  job_info = (data) => {

    this.props.history.push({ pathname: "/home/jobdetails", state: { data } })
  }

  handleMoreClick = () => {
    const { type } = this.props;
    if(type === 'ent'){
      tagRedirect(undefined,"enterprise")
    }else{
      tagRedirect({ WKEXP: '1,2' },"recommendedJob")
    }
  }


  render() {
    const { data, obj, children, type } = this.props;
    // data:数据
    // type：企业 ent  岗位 job
    return <div component-data="internshipCard">
      {
        <div className='omnibus_box' >
          <div className={`sf-page-tool-between  ${obj?.name}`}>
            <div className='omnibus_title'>
              <img src={obj?.img} />
              {obj?.title_html}
              <div className='omnibus_tips'>{obj?.tips}</div>
            </div>
            <div className='moreBtn' onClick={() => { this.handleMoreClick()}}
            >{'更多>>'}</div></div>
          {children}
          <div className={obj?.title === '热门企业' ? `ent_box` : `job_box`}>
            {
              data && data.length > 0 ?
                data.map((item) => {

                  return obj?.title === '热门企业' ?
                    <div className='ent_item'>
                      <img className='ent_logo' src={item?.LOGO ? filePath + 'enterprise/M' + item.id + '.png' : require("../../../img/pinzhunzhun/dataSource/ent_logo.png")} />
                      <div className='ent_info' onClick={() => { this.info(item) }}>
                        <div className='ent_name' title={item.ENTNAME}>{item.ENTNAME}</div>
                        <div className='ent_jobType' title={item?.INDTYPE_CN}>{item.INDTYPE_CN ? item.INDTYPE_CN : ""}</div>
                        <div className='requireTag_box'>
                          {
                            item?.TAG && item?.TAG.length > 0 ?
                              item?.TAG.map((item) => {
                                return <label>{item}</label>
                              })
                              : null
                          }
                        </div>
                      </div>
                    </div>
                    :
                    <JobCard data={item} history={this.props?.history} />

                })
                : <NoData width={"230px"} height={'230px'} />
            }
          </div>

        </div>
      }
    </div>
  }
}

export default card;